<template>
  <div class="chart" ref="mychart"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'leaderBoardEcharts',
  props: {
    rankingType: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      myChart: null,
      chartData: {
        citys: [],
        data: [],
      },
      option: {
        grid: {
          left: 0,
          right: '5%',
          bottom: 0,
          top: 0,
          containLabel: true,
        },
        xAxis: {
          show: false,
          type: 'value',
        },
        yAxis: [
          {
            type: 'category',
            inverse: true,
            axisLabel: {
              show: true,
              formatter (params) {
                if (params !== 'undefined' && params.length > 10) {
                  return `${params.slice(0, 10)}...`;
                }
                return params !== 'undefined' ? params : '';
              },
              textStyle: {
                color: '#ABD7FF',
                fontSize: this.fitChartSize(12),
                align: 'right',
                padding: [0, 0, 0, 0],
              },
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            data: [],
          },
          {
            type: 'category',
            inverse: true,
            axisTick: 'none',
            axisLine: 'none',
            show: true,
            axisLabel: {
              formatter (params) {
                return params !== 'undefined' ? Number(params).toFixed(0) : '';
              },
              textStyle: {
                padding: [0, 0, 0, this.fitChartSize(8)],
                color: '#fff',
                // fontWeight: 'bold',
                // align: 'right',
                fontSize: this.fitChartSize(10),
              },
            },
            data: [],
          },
        ],
        series: [
          {
            name: '值',
            type: 'bar',
            // showBackground: true,
            // backgroundStyle: {
            //   color: '#20406A',
            // },
            itemStyle: {
              normal: {
                barBorderRadius: this.fitChartSize(30),
                color () {
                  const topColor = 'rgba(3, 42, 89, 0.4)';
                  const bottomColor = '#51DAFF';
                  return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {
                      offset: 0,
                      color: topColor,
                    },
                    {
                      offset: 1,
                      color: bottomColor,
                    },
                  ]);
                },
              },
            },
            barWidth: this.fitChartSize(4),
            data: [],
            zlevel: 1,
          },
          {
            type: 'scatter',
            data: [],
            tooltip: {
              // show: true,
            },
            symbol: 'circle',
            symbolSize: [this.fitChartSize(10), this.fitChartSize(10)],
            symbolOffset: [this.fitChartSize(2), 0],
            zlevel: 2,
            itemStyle: {
              normal: {
                barBorderRadius: this.fitChartSize(10),
                color (params) {
                  const color = '#78EBFF';
                  return color;
                },
              },
            },
          },
          {
            type: 'effectScatter',
            data: [],
            tooltip: {
              show: false,
            },
            itemStyle: {
              normal: {
                barBorderRadius: this.fitChartSize(10),
                color (params) {
                  const color = '#78EBFF';
                  return color;
                },
              },
            },
            symbolSize: [this.fitChartSize(10), this.fitChartSize(10)],
            symbolOffset: [this.fitChartSize(2), 0],
          },
          {
            name: '背景',
            type: 'bar',
            barWidth: this.fitChartSize(4),
            barGap: '-100%',
            data: [0],
            itemStyle: {
              normal: {
                color: '#20406A',
                barBorderRadius: this.fitChartSize(10),
              },
            },
          },
        ],
      },
    };
  },
  watch: {
    rankingType: {
      handler(val) {
        this.handleData(val);
      },
      deep: true,
    },
  },
  mounted() {
    // this.initChart();
    window.addEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  methods: {
    handleData(data) {
      this.chartData={
        citys: [],
        data: [],
      };
      if (data && data.length > 0) {
        data.map((item) => {
          this.chartData.citys.push(item.stationName);
          this.chartData.data.push(item.todayPower);
        });
      } else {
        this.option = {
          title: {
            text: '暂无数据',
            x: 'center',
            y: 'center',
            textStyle: {
              fontSize: 14,
              fontWeight: 'normal',
            },
          },
        };
      }
      this.initChart();
    },
    // 监听变化重新渲染

    // 渲染图表
    initChart() {
      this.myChart = echarts.init(this.$refs.mychart);
      // console.log(this.chartData.citys);
      // console.log(this.chartData.data);
      const { citys } = this.chartData;
      const { data } = this.chartData;
      if (citys.length === 0 || data.length === 0) {
        this.option = {
          title: {
            text: '暂无数据',
            x: 'center',
            y: 'center',
            textStyle: {
              fontSize: this.fitChartSize(24),
              fontWeight: 'normal',
              color: '#fff',
            },
          },
        };
      } else {
        const datas = JSON.parse(JSON.stringify(this.chartData.data));
        const salvProMax = []; // 背景按最大值
        const max = datas[1];
        for (let i = 0; i < data.length; i++) {
          if (data[i] !== undefined) {
            salvProMax.push(max * 2);
          } else {
            salvProMax.push(0);
          }
        }
        this.option.yAxis[0].data = citys;
        this.option.yAxis[1].data = data;
        // datas[0] = datas[1] * 1;
        this.option.series[0].data = datas;
        this.option.series[1].data = datas;
        this.option.series[2].data = datas;
        this.option.series[3].data = salvProMax;
      }

      this.myChart.setOption(this.option, true);
    },
    // 窗口缩放，echart 动态调整大小
    handleWindowResize() {
      if (!this.myChart) return;
      this.myChart.resize();
    },
  },
};
</script>

<style scoped lang="less">
.chart {
  width: 373px;
  height: 100%;
  // margin-bottom: 19px;
}
</style>
